var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFvLeaderboardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 313,
    viewBox: "0 0 333 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.2374 297.698C71.3831 299.53 63.3009 300.818 48.5948 303.566L0.522122 101.813C-0.367657 98.0743 2.07924 94.3606 5.8608 93.7169C19.7512 91.3401 33.345 89.2109 47.0377 87.2798C50.6215 86.7847 53.9583 89.2605 54.5268 92.8504L86.2622 297.698H86.2374Z",
    fill: "url(#paint0_linear_179_76617)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.113 293.315C121.308 294.008 113.177 294.652 98.2235 296.261L73.7298 118.697C73.2108 114.983 75.8802 111.542 79.6123 111.171C92.6377 109.834 105.836 108.819 119.01 108.125C122.643 107.927 125.757 110.75 125.98 114.389L136.138 293.315H136.113Z",
    fill: "url(#paint1_linear_179_76617)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.661 7.21077L186.168 292.869C178.234 292.621 172.673 292.522 167.161 292.522C161.65 292.522 156.113 292.621 148.179 292.869L136.686 7.21077C136.538 3.49707 139.454 0.37756 143.137 0.278528C159.104 -0.0928426 175.194 -0.0928426 191.185 0.278528C194.893 0.37756 197.784 3.49707 197.636 7.21077H197.661Z",
    fill: "url(#paint2_linear_179_76617)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.815 44.9452L236.138 296.289C221.185 294.655 213.054 294.036 198.249 293.342L212.609 40.1669C212.807 36.478 215.97 33.6803 219.653 33.9031C234.754 34.8439 249.683 36.0076 264.859 37.4188C268.615 37.7654 271.334 41.2067 270.815 44.97V44.9452Z",
    fill: "url(#paint3_linear_179_76617)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.483 107.484L283.521 313C259.958 302.486 248.177 297.229 248.177 297.229L278.948 98.6204C279.467 95.3275 282.507 93.0003 285.819 93.4459C299.735 95.2533 313.724 97.432 327.614 99.9573C331.099 100.601 333.324 104.042 332.483 107.484Z",
    fill: "url(#paint4_linear_179_76617)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_179_76617",
    x1: 43.3006,
    y1: 87.2168,
    x2: 43.3006,
    y2: 303.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D4A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_179_76617",
    x1: 104.902,
    y1: 108.115,
    x2: 104.902,
    y2: 296.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D4A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_179_76617",
    x1: 167.171,
    y1: 0,
    x2: 167.171,
    y2: 292.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D4A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_179_76617",
    x1: 234.564,
    y1: 33.8907,
    x2: 234.564,
    y2: 296.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D4A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_179_76617",
    x1: 290.419,
    y1: 93.3912,
    x2: 290.419,
    y2: 313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D4A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFvLeaderboardBg);
export default __webpack_public_path__ + "static/media/fv-leaderboard-bg.7bfaca004ac83fdd77454c38336e2f50.svg";
export { ForwardRef as ReactComponent };